//
// CrosstabPickResultEntry.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";
import "../datagrid/DataGridPickResultEntry";
import "../models/data/tree/DataTreeNode";
import "./CrosstabPickButtonType";

var CrosstabPickResultEntry = createModule("commons_CrosstabPickResultEntry", [10053,10025,10017], ClosetObject, [
    ,
    ,
    ,
    {
        sourceDataSetName: 7,
        node: 1,
        cellWidth: 5,
        allOther: 2,
        buttonType: 4,
        x: 5,
        totalColumn: 2,
        hierarchyName: 7,
        index: 4,
        y: 5,
        cellHeight: 5,
        subtotalColumn: 2,
    },
    ,
    {
        _create: [4],
    },
    ,
]);
export default CrosstabPickResultEntry;
